{
  "cta": {
    "create-a-chart": "Create a chart"
  },
  "breadcrumb": {
    "dashboard": "Dashboard",
    "products": "Products",
    "charts": "Charts",
    "restock-alerts": "Restock Alerts",
    "settings": "Settings",
    "setting": "Settings",
    "account": "Account",
    "personal": "Personal",
    "organization": "Organization",
    "appearance": "Appearance",
    "themes": "Themes",
    "button": "Button",
    "font-family": "Font family",
    "uploads": "Uploads",
    "dimensions": "Dimensions",
    "notifications": "Notifications",
    "analytic": "Analytics",
    "analytics": "Analytics",
    "restock-settings": "Restock settings",
    "inventory": "Restock Alerts",
    "plans": "Plans",
    "billing": "Billing",
    "overview": "Overview",
    "plan-and-usage": "Plan and usage",
    "chart-views": "Chart views",
    "add-to-cart": "Add to cart",
    "buy-now": "Buy now",
    "size-recommendations": "Size recommendations",
    "stock-notifications": "Stock notifications",
    "reports": "Reports",
    "comparison": "Comparison",
    "images": "Uploads",
    "sidekick": "Sidekick",
    "import": "Import",
    "contact": "Contact",
    "help-articles": "Help articles",
    "support": "Support",
    "new": "New"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "Table-style Chart",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "Build a fully custom grid with complete control over every row, column, and measurement unit. Best for complex sizing across multiple regions.",
      "create-table-chart": "Create Table chart",
      "create-from-product": "Create from Product",
      "start-from-template": "Start from Template",
      "browse-templates": "Browse templates",
      "create-with-drag-drop": "Create with Drag & Drop",
      "creating": "Creating",
      "how-would-you-like-to-build-your-chart": "How would you like to<br /><span class=\"text-primary\">build your chart?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "Choose a method below, or tell us what you sell and we'll highlight the best fit.",
      "fastest-setup-2-min": "Fastest setup · ~2 min",
      "used-by-1000-merchants": "Used by 1000+ merchants",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "Auto-generate a matching size chart directly from your existing Shopify variant data. No manual entry — it reads your product and fills the table for you",
      "garment-templates-ready-to-use": "Garment templates ready to use",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "Pick from ready-made templates for tops, bottoms, shoes, belts, bags, and more. Customise any field after — great for getting started in under a minute.",
      "drag-drop-no-data-needed-upfront": "Drag & drop · no data needed upfront",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "Upload any product image and annotate measurements directly on it with drag & drop pins. Ideal for shoes, bags, accessories, and equipment.",
      "excel-like": "Excel like",
      "auto-generated": "Auto generated",
      "annotate-on-image": "Annotate on image",
      "what-are-you-selling": "What are you selling?",
      "category-clothing-apparel": "Clothing & apparel",
      "category-shoes": "Shoes",
      "category-accessories": "Accessories",
      "category-other": "Something else",
      "start-date": "Start date",
      "end-date": "End date"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "Select a product to create or link a size chart for that product.",
      "product-name": "Product name",
      "best-selling": "Best selling",
      "most-selling": "Most sold first",
      "least-selling": "Least selling",
      "best-selling-unavailable": "Sales data isn't available yet, so products are shown by last update.",
      "chart-attached": "Chart attached",
      "shopify-status": "Shopify status",
      "search-placeholder": "Search all products...",
      "vendors": "Vendors",
      "tags": "Tags",
      "statuses": "Statuses",
      "collections": "Collections",
      "types": "Types",
      "add-filter": "Add filter",
      "categories": "Categories",
      "search-and-filter-tooltip": "Search and Filter (F)",
      "import-selection": "Import selection",
      "failed-import-measurements": "Failed to import measurements",
      "product-updated": "Product updated successfully"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "Create, edit, duplicate or link a chart to a product from here.",
      "chart-name": "Chart name",
      "chart-type": "Chart type",
      "linked-to": "Linked to",
      "last-updated": "Last updated",
      "delete-x-charts": "Delete {{ x }} charts",
      "assigned-products": "Assigned products",
      "failed-to-fetch-products-data": "Failed to fetch products data",
      "delete-chart": "Delete chart",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "Are you sure you want to delete selected chart(s)? All products using chart(s) will be unassignd.",
      "successfully-deleted-chart-s": "Successfully deleted chart(s)!",
      "successfully-duplicated-chart": "Successfully duplicated chart!",
      "turn-this-into-a-conversion-chart": "Turn this into a Conversion chart",
      "upgradable-tooltip": "This table chart looks like a structured size chart and can be converted.",
      "convert-to-size-chart": "Convert to Size Chart",
      "convertibility-failed": "We couldn't check which table charts can be converted.",
      "convert": {
        "table-chart-info-callout": "This table chart can be upgraded to a smart size chart",
        "table-chart-info-callout-message": "Converting maps your grid to dimensions from your library, unlocking a visual measurement guide and model info a plain table can't show.",
        "successfully-converted": "Successfully converted to a size chart!",
        "detected-sizes": "Detected sizes",
        "at-least-two-sizes-are-needed": "At least two sizes are needed to convert this chart.",
        "unnamed-row": "Unnamed row",
        "ignore-this-row": "Ignore this row",
        "this-dimension-is-already-mapped": "This dimension is already mapped to another row.",
        "map-at-least-one-row": "Map at least one row to a dimension.",
        "finish-your-measurement-guide": "Finish your measurement guide",
        "measurement-points-without-values": "Measurement points without values ({{ x }})",
        "fill-them-in-after-converting": "Your selected image shows them, but your table had no such rows. Fill in their values after converting.",
        "measurements-without-points": "Measurements without a point on your image ({{ x }})",
        "no-image-selected-yet": "No image selected yet",
        "upload-an-image-then-drag-points": "Upload an image, then drag and drop the measurement points onto it.",
        "your-image-has-no-measurement-points": "Your selected image has no measurement points yet",
        "drag-measurement-points-onto-the-image": "Drag and drop their measurement points onto the image so shoppers can see where to measure.",
        "plus-x-more": "+{{ x }} more",
        "satisfied-button": "Looks good — make this my live chart",
        "satisfied-explanation": "Your table chart will be unpublished, this chart will be published, and its assigned products will move over.",
        "satisfied-success": "This chart is now live!",
        "step-x-of-y": "Step {{ x }} of {{ y }}",
        "choose-product-type": "Choose product type",
        "well-match-your-table-to-a-visual": "We'll match your table to the right visual product.",
        "save-settings": "Save settings",
        "review-table-mapping": "Review table mapping",
        "confirm-the-rows-to-convert": "Confirm the rows we should convert.",
        "existing-table": "Existing table",
        "sizes": "Sizes",
        "row": "Row",
        "column": "Column",
        "x-rows-need-review": "{{ x }} rows need review",
        "couldnt-match-this-row": "We couldn't match this measurement automatically",
        "change-match": "Change match",
        "view-values": "View values",
        "hide-values": "Hide values",
        "matched-automatically": "Matched automatically",
        "edit-matches": "Edit matches",
        "create-preview": "Create preview",
        "preview-ready": "Preview ready",
        "open-it-to-finish-the-missing-values": "Open it to finish the missing values.",
        "converted": "Converted",
        "open-preview": "Open preview",
        "you-can-add-them-in-the-preview": "You can add them in the preview."
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "Collect emails and send automatic back-in-stock notifications. Setup notification",
      "here": "here",
      "successfully-export-inventory-data": "Successfully export inventory data",
      "active-your-store-inventory-notification-feature": "Active your store's inventory notification feature",
      "in-order-to-receive-users-subscribed-for-your-products": "in order to receive users subscribed for your products.",
      "your-subscribers-have-been-delegeted-to-your": "Your subscribers have been delegeted to your"
    },
    "setting": {
      "storefront-popup-preview": "Storefront popup preview",
      "add-to-cart": "Add to cart",
      "buy-now": "Buy now",
      "sans-serif": "Sans serif",
      "serif": "Serif",
      "email-body-is-required": "Email Body is required",
      "list": "List",
      "category-image": "Category image",
      "pay-over-usage-cost": "Pay over usage cost",
      "over-usage-count": "Over usage count",
      "over-usage-cost": "Over usage cost",
      "x-usages": "{{ x }} usages",
      "failed-to-pay-over-usage-cost": "Failed to pay over usage cost",
      "manage-your-personal-information-and-account-perferences": "Manage your personal information and account preferences.",
      "manage-your-organization-contact-information-and-address": "Manage your organization's contact information and address.",
      "manage-your-billing-overview": "Review your billing details, plan, and payment information.",
      "manage-your-plan-and-usage": "View your current plan and usage limits.",
      "manage-your-measurement-dimensions": "Manage your measurement dimensions used across your size charts.",
      "dimension-translations": "Storefront translations",
      "dimension-translations-description": "Enter the label shoppers should see for each supported storefront language. Leave blank to use the default name.",
      "default-dimension-name": "Default dimension name",
      "dimension-name-description": "Used throughout the dashboard and as the storefront fallback when no translation is provided.",
      "storefront-label": "Storefront label",
      "naming": "Naming",
      "affecting-data": "Affecting data",
      "first-name-is-required": "First name is required",
      "last-name-is-required": "Last name is required",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "Subscribed for our latest news, exclusive offers, and exciting updates.",
      "contact-information": "Contact Information",
      "contact-name": "Contact name",
      "contact-name-is-required": "Contact name is required!",
      "contact-email": "Contact email",
      "contact-email-is-required": "Contact email is required!",
      "contact-email-is-invalid": "Contact email is invalid!",
      "company-organization-name": "Company/Organization name",
      "company-organization-name-is-required": "Company/Organization name is required",
      "street-address": "Street address",
      "street-address-is-required": "Street address is required!",
      "street-address-2": "Street address 2",
      "city": "City",
      "city-is-required": "City is required!",
      "state-province-region": "State/Province/Region",
      "state-province-region-is-required": "State/Province/Region is required!",
      "country": "Country",
      "country-is-required": "Country is required!",
      "postal-zip-code": "Postal/Zip code",
      "postal-zip-code-is-required": "Postal/Zip code is required!",
      "themes": "Themes",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "Customise your app's look! Choose a colour that best represents your brand",
      "sunset-ember": "Sunset Ember",
      "classic-noir": "Classic Noir",
      "system-background-colour": "System background colour",
      "customise-your-button": "Customise Your Button",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "Customise your button’s text, colour, and style to match your brand.",
      "what-should-the-button-say": "What should the button say?",
      "label-button-is-required": "Label button is required!",
      "text-colour": "Text colour",
      "text-colour-is-required": "Text colour is required!",
      "please-input-valid-hex-color-code": "Please input valid hex color code",
      "background-color": "Background color",
      "background-colour-is-required": "Background colour is required!",
      "font-size-in-px": "Font size in px",
      "font-size-in-px-is-required": "Font size in px is required!",
      "border-radius": "Border radius",
      "border-radius-is-required": "Border radius is required!",
      "successfully-updated-button-style": "Successfully updated button style",
      "font-family": "Font family",
      "customise-your-font": "Customise Your Font",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "Match your store's look and feel by updating the font across your size charts.",
      "select-a-font-from-the-list-bellow": "Select a font from the list bellow.",
      "search-font": "Search font...",
      "fetching-fonts": "Fetching fonts...",
      "showing-x-fonts": "Showing {{ x }} fonts",
      "sort-by-x": "Sort by {{ x }}",
      "most-popular": "Most popular",
      "here-how-it-will-look-on-your-shop": "Here's how it will look on your shop",
      "it-ll-updated-across-all-your-chart-displays": "It'll updated across all your chart displays.",
      "update-font-across-all-size-charts": "Update font across all size charts",
      "choose-a-font-to-match-your-store-style": "Choose a font to match your store's style",
      "apply-font": "Apply font",
      "font-applied-successfully": "Font applied successfully!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "Manage and delete your uploaded images. Removing a file is permanent and cannot be undone.",
      "do-you-want-to-delete-image": "Do you want to delete image?",
      "image-deleted-successfully": "Image deleted successfully",
      "chart-list": "Chart List",
      "delete-x-dimensions": "Delete {{ x }} dimensions",
      "view-affecting-data": "View affecting data",
      "no-data-will-be-affected": "No data will be affected.",
      "do-you-want-to-delete-selected-dimensions": "Do you want to delete selected dimensions?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "Any annotation sets and charts currently using these dimensions will have its annotation and data removed",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "Any annotation sets and charts currently using these dimensions will have its name changed",
      "delete-dimension": "Delete dimension",
      "successfully-deleted-dimension": "Successfully deleted dimension(s)!",
      "successfully-update-dimension": "Successfully update dimension!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "Configure how back-in-stock notifications work for your customers",
      "activate-back-in-stock-notifications": "Activate Back in Stock Notifications",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "Allow shoppers to subscribe for alerts when a size or product is sold out. Notifications will be sent automatically once stock is available.",
      "notification-channels": "Notification Channels",
      "third-party-service": "Third party service",
      "sms": "SMS",
      "coming-soon": "Coming soon",
      "signup-experience-design": "Signup Experience Design",
      "form-display": "Form Display",
      "modal-popup": "Modal Popup",
      "email-template-customisation": "Email Template Customisation",
      "subject-line": "Subject Line",
      "subject-line-is-required": "Subject Line is required",
      "your-size-is-back-in-stock": "Your size is back in stock 🎉",
      "email-body": "Email Body",
      "inventory-threshold-setting": "Inventory Threshold Setting",
      "notify-shoppers-when-inventory-reaches-at-least": "Notify shoppers when inventory reaches at least",
      "threshold-is-required": "Threshold is required",
      "threshold-must-be-greater-than-0": "Threshold must be greater than 0",
      "units": "units",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "Set the minimum inventory level required to trigger notifications",
      "choose-a-service": "Choose a service",
      "signing-out": "Signing out",
      "signout-of": "Signout of",
      "authenticate": "Authenticate",
      "save-settings": "Save Settings",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "Hi {{first_name}}, your {{product_name}} ({{size_variant}}) is now back in stock. Get it before it's gone!",
      "successfully-updated-notification-back-in-stock": "Successfully updated notification back in stock",
      "preferred-language": "Preferred language",
      "successfully-updated-your-profile": "Successfully updated your profile",
      "successfully-updated-mailing-subscription-status": "Successfully updated mailing subscription status!",
      "upgrade-plan": "Upgrade plan",
      "overview": "Overview",
      "billing-cycle": "Billing cycle",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "Billing cycle resets at midnight on {{ x }} and the next charge is on {{ y }}",
      "billing-information": "Billing Information",
      "update-billing": "Update billing",
      "monthly-total": "Monthly Total",
      "free-trial-x-days-left": "Free Trial - {{ x }} days left",
      "cancel-plan": "Cancel plan",
      "change-plan": "Change plan",
      "plan-and-usage": "Plan and Usage",
      "tier-offers-in-use": "Tier offers in use",
      "failed-to-cancel-plan": "Failed to cancel plan",
      "total-usage": "Total usage",
      "current-usage-summary": "Current usage summary",
      "published-charts": "Published charts",
      "limit-reached": "limit reached",
      "plan-details": "Plan details",
      "current-plan": "Current plan",
      "select-a-reason": "Select a reason",
      "please-provide-your-reason": "Please provide your reason",
      "chart-preferences": "Chart preferences",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "Skip picking dimensions when creating a new chart from template",
      "border-color": "Border color",
      "border-color-is-required": "Border color is required!",
      "list-of-charts-using-this-image": "List of charts using this image",
      "successfully-update-your-profile": "Successfully update your profile"
    },
    "analytic": {
      "failed-to-load-statistics": "Failed to load statistics",
      "total-chart-views": "Chart Views",
      "total-add-to-cart": "Add to cart",
      "traffic-by-location": "Traffic by Location",
      "desktop": "Desktop",
      "mobile": "Mobile",
      "size-recommendations": {
        "failed-to-load": "Failed to load size recommendations analytics",
        "total-suggestions-title": "Suggestions made",
        "conversion-title": "Conversion",
        "customers-proceeded": "Customers proceeded with suggestion",
        "of-x-suggestions": "of {{count}} suggestions",
        "most-suggested-title": "Most suggested product and variant",
        "suggestions-count": "{{count}} suggestions",
        "most-common-profile-title": "Most common profile",
        "average-profile-title": "Average profile",
        "gender": "Gender",
        "age-group": "Age group",
        "height": "Height",
        "weight": "Weight",
        "size-recommended": "Size recommended",
        "graph-suggestions": "Suggestions",
        "graph-proceed": "Proceed",
        "source-all": "All",
        "source-chart": "Size chart",
        "source-table-chart": "Table chart"
      },
      "chart-views": {
        "failed-to-load": "Failed to load chart views",
        "device-types": "Device types",
        "most-viewed-chart": "Most viewed chart",
        "most-viewed-product": "Most viewed product",
        "views-count": "{{ count }} views",
        "view-at": "View at",
        "location": "Location",
        "graph-label": "Views"
      },
      "add-to-cart": {
        "failed-to-load": "Failed to load add to cart analytics",
        "estimated-revenue": "Estimated value influenced",
        "conversion-title": "View chart → Add to cart conversion",
        "most": "Most add to cart",
        "adds-count": "{{count}} add to carts",
        "added-at": "Added at",
        "graph-label": "Add to carts",
        "views-dataset-label": "Views",
        "add-to-cart-dataset-label": "Add to cart"
      },
      "stock-notifications": {
        "failed-to-load": "Failed to load stock notifications analytics",
        "failed-to-load-table": "Failed to load stock notifications table",
        "total-subscriptions": "Subscriptions",
        "total-notifications-sent": "Notifications sent",
        "delivery-rate": "Delivery rate",
        "opened-of-notified": "{{ opened }} opened / {{ notified }} notified",
        "most-subscribed": "Most subscribed",
        "subscriptions-count": "{{ count }} subscriptions",
        "latest-subscribed": "Latest subscribed",
        "subscribed-at": "Subscribed at: {{ date }}",
        "longest-waiting": "Longest waiting for restock",
        "waiting-days": "Waiting: {{ days }} days",
        "waiting-since": "(since {{ date }})",
        "subscriptions": "Subscriptions",
        "notifications-sent": "Notifications Sent",
        "opened": "Opened",
        "at": "At",
        "graph-label": "Subscriptions"
      },
      "paid-gate": {
        "unlock-message": "Unlock advanced analytic to view full data and make better decisions.",
        "upgrade": "Upgrade",
        "failed-to-fetch-plans": "Failed to fetch plans"
      },
      "buy-now": {
        "failed-to-load": "Failed to load buy now analytics",
        "total": "Buy Now",
        "estimated-revenue": "Estimated value influenced",
        "conversion-title": "View chart → Buy now conversion",
        "most": "Top Buy Now product",
        "buys-count": "{{count}} buy nows",
        "graph-label": "Buy nows",
        "views-dataset-label": "Views",
        "buy-now-dataset-label": "Buy now",
        "clicked-at": "Clicked at"
      },
      "overview": {
        "funnel-title": "Where size-chart views went",
        "no-views-title": "No chart views in this range",
        "no-views-hint": "Size charts appear on product pages once they are published and assigned to products.",
        "chart-views-caption": "Shoppers who opened a size chart",
        "baseline-caption": "Everything below is measured against these views",
        "of-views": "of {{ count }} views",
        "not-in-funnel": "Not part of the chart funnel"
      },
      "preview": {
        "title": "No data yet — this is a preview",
        "message": "The figures below are sample data showing how this page will look once shoppers start using your size charts."
      }
    },
    "plans": {
      "popular-plan": "Popular Plan",
      "try-now": "Try now",
      "activated": "Activated",
      "contact-sales": "Contact Sales",
      "try-free-for-1-month": "Try free for 1 month",
      "activate": "Activate",
      "what-included": "What's included?",
      "choose-the-plan-that-fits-your-business-needs": "Choose the plan that fits your business needs",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "Whether you're just starting out or looking for a robust sizing solution, we've got a plan that's right for you.",
      "monthly": "Monthly",
      "annually": "Annually",
      "compare-plan-features": "Compare plan features",
      "compare-all-plan-features": "Compare all plan features",
      "feature-usages": "Usages",
      "feature-analytics": "Analytics",
      "feature-support": "Support",
      "feature-integration": "Integration",
      "feature-branding": "Branding",
      "feature-api-access": "API Access",
      "feature-stock-notifications": "Stock Notifications",
      "feature-published-conversion-charts": "Published Conversion Charts",
      "feature-advanced-variant-mapping": "Advanced Variant Mapping",
      "failed-to-fetch-plans": "Failed to fetch plans",
      "failed-to-activate-plan": "Failed to activate plan",
      "contact": {
        "title": "Contact Sales",
        "subtitle": "Tell us about your store and what you need. Our team will get back to you by email.",
        "message-placeholder": "How can we help your business?",
        "send": "Send message",
        "success": "Thanks! Your message was sent. Our team will reach out shortly.",
        "first-name-required": "First name is required",
        "last-name-required": "Last name is required",
        "email-required": "Email is required",
        "email-invalid": "Email is invalid",
        "message-required": "Message is required"
      },
      "invite": {
        "title": "Complete your subscription",
        "your-plan": "Your plan",
        "order-summary": "Order summary",
        "billed-every-30-days": "Billed every 30 days",
        "billed-yearly": "Billed yearly",
        "free-trial": "{{days}}-day free trial",
        "due-today": "Due today",
        "then-every-30-days": "Then {{price}} USD every 30 days",
        "then-yearly": "Then {{price}} USD every year",
        "continue": "Continue to approval",
        "shopify-note": "Billed through Shopify. You'll approve the charge on the next screen.",
        "switching-note": "This replaces your current plan once you approve. Shopify applies any credit for the time left on it.",
        "already-on-plan": "You're on this plan",
        "unavailable-title": "This invitation is no longer available",
        "unavailable-body": "The link may have expired. Contact the person who sent it, or see the plans open to every store.",
        "see-plans": "See plans",
        "failed-title": "This plan couldn't be loaded",
        "failed-body": "Check your connection and reload the page."
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "Please sign in",
        "email-is-required": "Email is required",
        "invalid-email-address": "Invalid email address",
        "password-is-required": "Password is required",
        "sign-in": "Sign in",
        "reset-password": "Reset password",
        "generic-error": "There was an error in process! Please try again later."
      }
    },
    "admin": {
      "reports": {
        "title": "Reports",
        "chart-views": {
          "title": "Chart views",
          "description": "See how many times shoppers opened the size chart, globally across all stores.",
          "failed-to-load": "Failed to load chart views report",
          "total-views": "Chart Views",
          "most-viewed-chart": "Most viewed chart",
          "most-viewed-product": "Most viewed product",
          "views-count": "{{ count }} views",
          "traffic-by-location": "Traffic by Location",
          "device-types": "Device types",
          "desktop": "Desktop",
          "mobile": "Mobile",
          "top-stores": "Top stores",
          "no-top-stores": "No store data yet",
          "graph-label": "Views",
          "view-at": "View at",
          "location": "Location"
        },
        "add-to-cart": {
          "title": "Add to cart",
          "description": "See how the size chart influences add-to-cart events, globally across all stores.",
          "failed-to-load": "Failed to load add to cart report",
          "total-add-to-cart": "Add to cart",
          "conversion-title": "View chart → Add to cart conversion",
          "most": "Most add to cart",
          "adds-count": "{{ count }} add to carts",
          "top-stores": "Top stores",
          "no-top-stores": "No store data yet",
          "graph-label": "Add to carts",
          "views-dataset-label": "Views",
          "add-to-cart-dataset-label": "Add to cart",
          "added-at": "Added at"
        },
        "buy-now": {
          "title": "Buy now",
          "description": "See how the size chart influences buy-now events, globally across all stores.",
          "failed-to-load": "Failed to load buy now report",
          "total-buy-now": "Buy Now",
          "conversion-title": "View chart → Buy now conversion",
          "most": "Top Buy Now product",
          "buys-count": "{{ count }} buy nows",
          "top-stores": "Top stores",
          "no-top-stores": "No store data yet",
          "graph-label": "Buy nows",
          "views-dataset-label": "Views",
          "buy-now-dataset-label": "Buy now",
          "clicked-at": "Clicked at"
        },
        "conversion-funnel": {
          "title": "Table chart conversion",
          "description": "See where merchants give up when turning a table chart into a size chart, globally across all stores.",
          "failed-to-load": "Failed to load table chart conversion report",
          "total-runs": "Conversions started",
          "runs-breakdown": "{{ converted }} converted · {{ handedOver }} handed over",
          "conversion-title": "Started → Converted",
          "handover-rate": "{{ rate }}% went on to hand over their products",
          "handover-gap-title": "Converted, not handed over",
          "of-converted-runs": "of converted attempts",
          "handover-gap-description": "A hand-over can happen days later, so some of these are still pending rather than abandoned.",
          "funnel-title": "Conversion funnel",
          "funnel-note": "The dedicated hand-over step is no longer triggered — the banner is how hand-overs get completed now, so read its count as the hand-over total rather than a step conversion.",
          "no-funnel": "No conversion attempts in this range",
          "drop-off": "drop-off",
          "runs-dataset-label": "Attempts",
          "drop-offs-title": "Where attempts end",
          "drop-offs-description": "The last thing every attempt did. Attempts ending on a completed hand-over — now recorded via the banner — finished successfully.",
          "no-drop-offs": "No conversion attempts in this range",
          "dwell-title": "Time before leaving",
          "dwell-description": "Only recorded when a merchant abandons a step, plus the time spent reading the review before confirming.",
          "no-dwell": "No timing data in this range",
          "step": "Step",
          "samples": "Samples",
          "median": "Median",
          "p90": "P90",
          "top-stores": "Top stores",
          "no-top-stores": "No store data yet",
          "graph-label": "Conversions started",
          "started-at": "Started at",
          "duration": "Duration",
          "last-step": "Last step",
          "outcome": "Outcome",
          "steps": {
            "entry": "Dialog opened",
            "category": "Category",
            "mapping": "Mapping",
            "summary": "Review",
            "convert": "Convert",
            "handover": "Hand-over",
            "banner": "Banner"
          },
          "actions": {
            "viewed": "viewed",
            "completed": "completed",
            "skipped": "skipped",
            "back": "went back",
            "abandoned": "abandoned",
            "failed": "failed",
            "customize_clicked": "customize clicked",
            "dismissed": "dismissed"
          },
          "outcomes": {
            "handed-over": "Handed over",
            "converted": "Converted only",
            "failed": "Failed",
            "abandoned": "Abandoned",
            "in-progress": "In progress"
          }
        }
      },
      "delete-category": "Delete category",
      "do-you-want-to-delete-selected-categories": "Do you want to delete the selected categories?",
      "global-categories-are-shared-by-every-store": "Global categories are shared by every store — deleting one affects all of them. This cannot be undone.",
      "successfully-deleted-category": "Category deleted successfully",
      "average-cost-per-recommendation": "Average Cost per Recommendation",
      "failed-to-load-recommendations-average-cost": "Failed to load recommendations average cost",
      "most-expensive-extract": "Most expensive extract",
      "most-expensive-recommendation": "Most expensive recommendation",
      "total-recommendation-cost": "Total recommendation cost",
      "total-size-recommendation": "Size recommendations",
      "total-sheet-extract": "Sheet extracts",
      "new-category": "New category",
      "category-created-unlisted-hint": "The category is created un-listed. Add an image and measurements before publishing it to stores.",
      "category-created-successfully": "Category created successfully!",
      "category-search-placeholder": "Image name, store name...",
      "dimension-search-placeholder": "Dimension name, store name...",
      "category-not-found": "Category not found",
      "sub-categories-variants": "Sub categories/ variants:",
      "add-sub-category-variant": "Add sub category/ variant:",
      "from-existing": "From existing",
      "create-a-new": "Create a new",
      "sub-category-removed": "Sub category removed!",
      "remove-sub-category": "Remove sub category",
      "remove-sub-category-confirm": "Remove {{ x }} from this category? It stays available as a top-level category.",
      "update-category": "Update category",
      "published-category-hint": "A published category is visible to all stores. Un-listed categories stay hidden.",
      "category-updated-successfully": "Category updated successfully!",
      "uninstalled": "Uninstalled",
      "inactive": "Inactive",
      "install-at": "Install at",
      "total-chart-views": "Chart views",
      "chart-view-at": "Chart view at",
      "store-id": "Store ID",
      "successfully-deleted-clients": "Successfully deleted clients!",
      "session-replay": "Session Replay",
      "watch-on-amplitude": "Watch on Amplitude",
      "shopify-app": "Shopify App",
      "shops-online-store": "Shop's Online Store",
      "no-more-events-to-load": "No more events to load!",
      "failed-to-fetch-events": "Failed to fetch events!",
      "info": "Info",
      "store-info": "Store info",
      "days-ago": "{{ x }} days ago",
      "contact-email": "Contact email",
      "store-url": "Store URL",
      "activities": "Activities",
      "insights": "Insights",
      "subscriptions": "Subscriptions",
      "failed-to-fetch-client-info": "Failed to fetch client info!",
      "failed-to-load-add-to-cart-analytics": "Failed to load add to cart analytics",
      "failed-to-load-buy-now-analytics": "Failed to load buy now analytics",
      "failed-to-load-chart-views": "Failed to load chart views",
      "failed-to-load-size-recommendations-analytics": "Failed to load size recommendations analytics",
      "failed-to-load-stock-notifications-analytics": "Failed to load stock notifications analytics",
      "failed-to-load-stock-notifications-table": "Failed to load stock notifications table",
      "chart-views": "Chart views",
      "add-to-cart": "Add to cart",
      "buy-now": "Buy now",
      "size-recommendations": "Size recommendations",
      "stock-notifications": "Stock notifications",
      "change-details": "Change details",
      "plan-subscription-details": "Plan subscription details",
      "ai-size-recommendation-limit": "AI Size Recommendation Limit",
      "ai-size-recommendation-limit-required": "AI size recommendation limit is required!",
      "minimum-limit-is-0": "Minimum limit is 0!",
      "unlimited": "Unlimited",
      "chart-limit-drafts-hint": "Only published charts count. Drafts are unlimited.",
      "chart-limit-required": "Chart limit is required!",
      "chart-limit-whole-number": "Limit must be a whole number!",
      "stock-notification-limit": "Stock Notification Limit",
      "stock-notification-limit-required": "Stock notification limit is required!",
      "published-size-chart-limit": "Published Size Chart Limit",
      "published-table-chart-limit": "Published Table Chart Limit",
      "analytic": "Analytic",
      "full-suite": "Full Suite",
      "select-a-subscription-plan": "Select a subscription plan",
      "failed-to-fetch-plans": "Failed to fetch plans!",
      "new-plan": "New plan",
      "failed-to-assign-plan-subscription-to-client": "Failed to assign plan subscription to client!",
      "ai-size-recommendation": "AI Size Recommendation",
      "stock-notification": "Stock Notification",
      "published-size-charts": "Published Size Charts",
      "published-table-charts": "Published Table Charts",
      "analytic-access": "Analytic Access",
      "activated-at": "Activated at",
      "usages": "Usages",
      "failed-to-fetch-client-plan-subscription": "Failed to fetch client plan subscription!",
      "advanced-variant-mapping": "Advanced variant mapping",
      "advanced-variant-mapping-description": "Charts use their own sizes on every assigned product, and Add to cart picks the matching product variant. When off, a chart's sizes must match each product's variant names exactly.",
      "advanced-variant-mapping-counts": "{{ total }} charts · {{ x }} on advanced variant mapping",
      "advanced-variant-mapping-drift": "{{ x }} charts don't match this setting.",
      "advanced-variant-mapping-repair": "Repair",
      "turn-on-advanced-variant-mapping": "Turn on advanced variant mapping?",
      "turn-off-advanced-variant-mapping": "Turn off advanced variant mapping?",
      "advanced-variant-mapping-on-body": "All {{ x }} charts of this client switch immediately, and new charts will use it too. Measurements are not changed, and you can turn it off again.",
      "advanced-variant-mapping-off-body": "All {{ x }} charts of this client go back to exact variant-name matching. Charts whose sizes were renamed while it was on (e.g. \"Blue / S\" to \"S\") will show empty measurements on products whose variant names no longer match.",
      "turn-on": "Turn on",
      "turn-off": "Turn off",
      "failed-to-fetch-advanced-variant-mapping": "Failed to fetch advanced variant mapping!",
      "failed-to-update-advanced-variant-mapping": "Failed to update advanced variant mapping!",
      "plan-used-as-free-trial": "Plan used as free trial for new registered client",
      "x-usages": "{{ x }} usages",
      "successfully-updated-configuration-value": "Successfully updated configuration value",
      "only-authorized-personnel-hint": "Only authorized personnel are allowed to access and modify the application global configuration!",
      "password-is-required": "Password is required",
      "authorize": "Authorize",
      "1-month": "1 month",
      "3-months": "3 months",
      "6-months": "6 months",
      "1-year": "1 year",
      "failed-to-load-costs": "Failed to load costs",
      "failed-to-load-total-recommendations": "Failed to load total recommendations",
      "archived": "Archived",
      "billing-interval": "Billing interval",
      "plan-information": "Plan Information",
      "name-is-required": "Name is required!",
      "features": "Features",
      "stock-notification-recommendation-limit": "Stock Notification Recommendation Limit",
      "popular": "Popular",
      "allow-trial": "Allow trial",
      "interval": "Interval",
      "interval-is-required": "Interval is required!",
      "price-is-required": "Price is required!",
      "minimum-price-is-0": "Minimum price is 0!",
      "discounted-from": "Discounted From",
      "description": "Description",
      "description-is-required": "Description is required!",
      "selling-points": "Selling points",
      "selling-point-x": "Selling point {{ x }}",
      "selling-point-is-required": "Selling point is required!",
      "analytic-is-required": "Analytic is required!",
      "support": "Support",
      "support-is-required": "Support is required!",
      "status-is-required": "Status is required!",
      "manage-preset-dimensions": "Manage preset dimensions, their detection synonyms, and translations.",
      "detection-synonyms": "Detection synonyms",
      "add-synonym-placeholder": "Type a synonym and press Enter",
      "translations": "Translations",
      "missing-translation": "Missing translation",
      "new-dimension": "New dimension",
      "edit-dimension": "Edit dimension",
      "delete-preset-dimension": "Delete preset dimension",
      "do-you-want-to-delete-this-preset-dimension": "Do you want to delete \"{{ name }}\"?",
      "preset-dimensions-are-shared-by-every-store": "Preset dimensions are shared by every store — deleting one removes it from all categories that use it. This cannot be undone.",
      "successfully-created-dimension": "Dimension created successfully!",
      "successfully-updated-dimension": "Dimension updated successfully!",
      "successfully-deleted-dimension": "Dimension deleted successfully!",
      "ai-provider-for-file-imports": "AI provider for file imports",
      "no-api-key-configured-in-this-environment": "No API key configured in this environment",
      "ai-provider-saved-applies-to-new-imports": "AI provider saved. It applies to new imports; imports already running keep their provider.",
      "ai-provider-for-size-recommendations": "AI provider for size recommendations",
      "ai-provider-saved-applies-to-next-recommendation": "AI provider saved. It applies from the next size recommendation.",
      "size-recommendation-provider-hint": "Used for shoppers' AI size recommendations. Separate from file imports.",
      "support-agent": {
        "title": "Support agent",
        "enabled": "Support agent answers merchants",
        "enabled-hint": "Saves as soon as you switch it. While it's off, the chat takes no new questions; conversations already with the team stay open.",
        "turned-on": "Support agent turned on",
        "turned-off": "Support agent turned off",
        "provider": "AI provider for the support agent",
        "provider-saved": "AI provider saved. It applies to the agent's next reply.",
        "provider-not-configured": "That provider has no API key in this environment, so it wasn't saved.",
        "rate-limit": "Messages per shop per minute",
        "daily-cap": "Messages per shop per day",
        "whole-number": "Enter a whole number of at least 1.",
        "limits-hint": "Each shop's limits on messages the agent answers.",
        "limits-saved": "Limits saved",
        "invalid-limit": "The server rejected a limit: each must be a whole number of at least 1."
      },
      "ai-measurement-import": "AI measurement import",
      "name-admin-only": "Name (admin only)",
      "name-admin-only-hint": "The app recognises the Free and Enterprise plans by this name, so don't rename those.",
      "display-name": "Display name",
      "display-name-hint": "Shown to merchants on the plans page, billing pages and the Shopify charge. Leave blank to use the name.",
      "display-name-too-long": "Display name can be at most 40 characters!",
      "availability": "Availability",
      "available-from-utc": "Available from (UTC)",
      "available-from-hint": "Leave blank to offer it as soon as it's active.",
      "expires-at-utc": "Expires at (UTC)",
      "expires-at-required": "Set when it expires!",
      "window-order": "It must become available before it expires!",
      "your-time": "Your time: {{time}}",
      "availability-always": "Always offered",
      "availability-scheduled": "Scheduled: not offered yet",
      "availability-live": "Live: offered now",
      "availability-ended": "Ended: no longer offered",
      "promo-plan": "Promo plan",
      "replaces-plan": "Replaces",
      "replaces-plan-none": "Nothing (a regular plan)",
      "replaces-plan-hint": "While this plan is offered, merchants see it instead of the plan it replaces.",
      "campaign": "Campaign",
      "campaign-required": "Pick the campaign this promo plan belongs to!",
      "merchants-see": "Merchants see",
      "replaces-x": "replaces {{x}}",
      "archiving-hint": "Archiving hides a plan from new subscribers only. Current subscribers keep it.",
      "duplicate-as-promo-plan": "Duplicate as promo plan",
      "help-articles": {
        "topic": "Topic",
        "all-topics": "All topics",
        "topics": {
          "getting-started": "Getting started",
          "size-charts": "Size charts",
          "table-charts": "Table charts",
          "assigning-products": "Assigning products",
          "storefront-display": "Storefront display",
          "chart-import": "Chart import",
          "size-recommendations": "Size recommendations",
          "plans-billing": "Plans & billing",
          "troubleshooting": "Troubleshooting"
        },
        "new-article": "New help article",
        "slug": "Slug",
        "slug-hint": "The article's address on the help centre: /help/your-slug. Changing it breaks links to the old address.",
        "slug-invalid": "Use lowercase letters, numbers and single hyphens.",
        "slug-taken": "Another article already uses this slug.",
        "title-is-required": "Title is required",
        "summary": "Summary",
        "summary-hint": "One line. The support agent chooses articles by their summary.",
        "summary-is-required": "Summary is required",
        "order": "Order",
        "body-hint": "Markdown. Link another article with [text](/help/its-slug).",
        "insert-image": "Insert image",
        "image-upload-failed": "Couldn't upload the image.",
        "view-on-help-centre": "View on help centre",
        "broken-links": "Published, but these links point to articles that don't exist or aren't published:",
        "article-saved": "Article saved",
        "article-published": "Article published",
        "article-unpublished": "Article unpublished",
        "article-deleted": "Article deleted",
        "delete-article": "Delete article",
        "delete-article-prompt": "Delete \"{{title}}\"? It disappears from the help centre and the support agent at once.",
        "load-failed": "Couldn't load the article.",
        "export": "Export",
        "import": "Import",
        "export-failed": "Couldn't export the articles.",
        "import-title": "Import help articles",
        "import-checking": "Checking the file…",
        "import-preview": "{{file}} will create {{created}} and update {{updated}} articles, with {{images}} images. Articles that aren't in the file stay as they are.",
        "import-invalid": "This file can't be imported:",
        "imported": "Imported: {{created}} created, {{updated}} updated."
      },
      "support-chat": {
        "statuses": {
          "needs_follow_up": "Needs follow-up",
          "with_admin": "With admin",
          "agent": "Agent",
          "resolved": "Resolved"
        },
        "refresh": "Refresh",
        "shop-search": "Search by shop domain",
        "unread-only": "Unread only",
        "unread": "Unread",
        "shop-removed": "Shop no longer exists",
        "waiting-since": "Waiting since",
        "last-message": "Last message",
        "open": "Open conversation",
        "back-to-queue": "Back to queue",
        "load-failed": "Couldn't load this conversation.",
        "request-summary": "The agent asked for a person on {{date}}:",
        "reply-placeholder": "Reply to the merchant",
        "reply-hint": "The merchant is notified at once, and the conversation moves to With admin.",
        "send-reply": "Send reply",
        "reply-sent": "Reply sent",
        "hand-back": "Hand back to agent",
        "handed-back": "Handed back to the agent",
        "resolve": "Resolve",
        "resolved": "Conversation resolved",
        "no-plan": "None"
      },
      "invite-only": "Invite-only",
      "invite-only-hint": "Hidden from the plans page. Anyone with the plan's link can subscribe. This can't be changed after the plan is created.",
      "invite-only-price-required": "An invite-only plan needs a price above 0",
      "copy-invite-link": "Copy invite link",
      "invite-link-copied": "Invite link copied",
      "invite-link-copy-failed": "Couldn't copy the invite link"
    }
  },
  "search": {
    "no-result-found": "No result found!",
    "type": {
      "product": "Product",
      "variant": "Variant",
      "client": "Client"
    },
    "show-less": "Show less",
    "show-full": "Show full",
    "search-x-by-full-name": "Search {{ x }} by full name",
    "load-more...": "Load more..."
  },
  "privacy-policy": "Privacy Policy",
  "contact-us": "Contact Us",
  "notification": {
    "notification": "Notification",
    "mark-all-as-read": "Mark all as read",
    "compose": "Compose notification",
    "title-required": "Title is required!",
    "message-required": "Message is required!",
    "sent-to-all-clients": "A notification has been sent to all clients"
  },
  "table": {
    "sort": "Sort",
    "sort-by": "Sort by",
    "oldest-first": "Oldest first",
    "newest-first": "Newest first",
    "a-z": "A to Z",
    "z-a": "Z to A",
    "lowest-first": "Lowest first",
    "highest-first": "Highest first",
    "no-data-found": "No data found"
  },
  "grading": {
    "grading-configuration": "Grading configuration",
    "base-size": "Base size",
    "enter-your-grading-allowances": "Enter your grading allowances",
    "base": "Base"
  },
  "chart": {
    "image-nav-previous": "Previous image",
    "image-nav-next": "Next image",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "Add another image",
    "image-add-slot-formats": "Accepts .png, .jpeg, .jpg",
    "image-cap-reached": "You've reached the maximum number of images for this category.",
    "image-upload-failed": "The image could not be uploaded. Please try again.",
    "image-svg-not-accepted": "SVG files are not accepted here.",
    "image-delete": "Delete image",
    "image-move-left": "Move image left",
    "image-move-right": "Move image right",
    "image-delete-confirm-title": "Delete this image?",
    "image-delete-confirm-body": "This image will be permanently removed and cannot be recovered.",
    "image-delete-confirm-cancel": "Cancel",
    "image-delete-confirm-action": "Delete image",
    "image-delete-last-tooltip": "A category must keep at least one image.",
    "image-customize-first-tooltip": "Customize this category first to manage its images.",
    "image-delete-failed": "The image could not be deleted. Please try again.",
    "image-reorder-failed": "The images could not be reordered. Please try again.",
    "do-you-want-to-delete-this-chart": "Do you want to delete this chart?",
    "unnamed-chart": "Unnamed chart",
    "get-size-chart-permalink": "Get size chart permalink",
    "chart-external-link-is-copied-to-clipboard": "Chart's external link is copied to clipboard",
    "failed-to-duplicate-chart": "Failed to duplicate chart",
    "failed-to-create-chart": "Failed to create chart",
    "add-new-layout-blocks": "Add new layout blocks",
    "click-on-these-layout-types-and-add-to-the-size-chart": "Click on these layout types and add to the size chart",
    "rename-chart": "Rename chart",
    "chart-renamed-successfully": "Chart renamed successfully",
    "failed-to-rename-chart": "Failed to rename chart",
    "preview": "Preview",
    "model-info": "Model Info",
    "model-details": "Model Details",
    "help-shoppers-by-showing-the-model-height-and-size": "Help shoppers by showing the model's height and size",
    "model-name": "Model Name",
    "enter-model-name": "Enter model name",
    "model-height": "Model Height",
    "please-enter-valid-number": "Please enter valid number",
    "size-worn": "Size Worn",
    "show-variants-by": "Show variants by",
    "add-options-like-size-or-color": "Add options like size or color",
    "select-existing-chart": "Select existing chart",
    "search-charts": "Search charts by name",
    "no-charts-found": "No charts found",
    "search-dimensions": "Search dimensions",
    "no-dimensions-found": "No dimensions found",
    "add-a-new-size-chart": "Add a New Size Chart",
    "this-product-is-using-table-chart": "This product is using table chart",
    "update-your-size-chart": "Update Your Size Chart",
    "create-your-size-chart": "Create Your Size Chart",
    "use-a-template": "Use a template",
    "use-template-variants": "Use template & Variants",
    "pick-a-method-to-get-started": "Pick a method to get started",
    "select-an-existing-chart": "Select an existing chart",
    "image-set-annotation-panel": "Image set annotation panel",
    "measure-guide": "Measure guide...",
    "drag-drop-to-mark-measurement-bubble": "Drag & drop to mark measurement bubble",
    "are-you-sure-you-want-to-delete-all-measurements": "Are you sure you want to delete all measurements?",
    "accepts-png-jpeg-jpg-svg": "Accepts .png, .jpeg, .jpg, .svg",
    "this-name-will-appear-in": "This name will appear in",
    "image-set": "image set",
    "added-measurements": "Added measurements",
    "no-measurements-added-yet": "No measurements added yet",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "Drag and drop a chip to edit its line on the canvas",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "After adding a measurement, drag and drop it from the 'Added measurements' section above onto the image",
    "across-shoulder-front-rise-belt": "Across shoulder, Front rise, Belt, ...",
    "create-measurement": "Create measurement",
    "examples-across-shoulder-front-rise-cuff-width": "Examples: 'Across shoulder', 'Front rise', 'Cuff width'",
    "delete-anotation-set": "Delete anotation set",
    "this-will-remove-all-measurements-from-this-image": "This will remove all measurements from this image",
    "measurement-name": "Measurement name",
    "size-recommender": "Size Recommender",
    "size-recommender-history": "Recent recommendations",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "Your buyer’s personal fitting assistant that instantly suggests the perfect size, every time",
    "stretch-factor": "Stretch factor",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "How stretchy is the fabric? A rough estimate is enough. If unsure, then leave at 10%",
    "easing": "Easing",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "Wearing ease is the amount added to a person's body measurements so one can move in a garment.",
    "set-default": "Set Default",
    "suggested": "Suggested",
    "assign-chart": "Assign chart",
    "your-chart-has-not-been-assigned-to-any-product-yet": "Your chart has not been assigned to any product yet",
    "assign-your-chart-so-it-will-appear-on-product-pages": "Assign your chart so it will appear on product pages",
    "assign-it-to-a-product": "Assign it to a product",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "Select the products or collections where you want your size chart to appear",
    "x-matched-y": "{{ x }} matched {{ y }}",
    "overwritting-x-products": "(overwritting {{ x }} products)",
    "calculating...": "Calculating...",
    "select-product-or-collection": "Select product or collection",
    "remove-all": "Remove all",
    "are-you-sure-you-want-to-remove-all-conditions": "Are you sure you want to remove all conditions?",
    "list-of-matched-products": "List of matched products",
    "give-your-size-chart-a-name": "Give your size chart a name",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "This name is only used internally to help you organise your charts. Customers won’t see it.",
    "eg-mens-t-shirt-size-chart": "e.g Men's T-Shirt Size Chart",
    "add-text-block": "Add text block",
    "product-image-optional": "Product Image (optional)",
    "add-layout-block": "Add layout block",
    "move-this-block-up": "Move this block up",
    "move-this-block-down": "Move this block down",
    "clear-this-image": "Clear this image",
    "align-this-image": "Align this image",
    "clear-this-video": "Clear this video",
    "apply-grading-to-this-table": "Apply grading to this table",
    "duplicate-this-block-to-below": "Duplicate this block to below",
    "remove-this-block": "Remove this block",
    "upload-an-image": "Upload an image",
    "browse-to-upload": "Browse to upload",
    "choose-from-our": "Choose from our",
    "ready-made-templates": "ready-made templates",
    "select-a-template": "Select a template",
    "new-row": "New row",
    "new-column": "New column",
    "add-column-left": "Add column left",
    "add-column-right": "Add column right",
    "move-left": "Move left",
    "move-right": "Move right",
    "freeze": "Freeze",
    "unfreeze": "Unfreeze",
    "delete-column": "Delete column",
    "add-row-above": "Add row above",
    "add-row-below": "Add row below",
    "move-up": "Move up",
    "move-down": "Move down",
    "delete-row": "Delete row",
    "insert-video": "Insert video",
    "select-a-video": "Select a video",
    "paste-a-link-to-a-video-here": "Paste a link to a video here",
    "webgl-not-supported": "Your browser does not support WebGL. Please turn WebGL support on if you are using a modern browser like Chrome, Firefox, or Safari.",
    "table-chart-created": "Table chart created",
    "name-this-image-set": "Name this image set",
    "name-your-import": "Name your import",
    "table-chart-updated": "Table chart updated",
    "chart-updated": "Chart updated",
    "use-how-to-measure-block": "Use how to measure block? (Optional)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "A text block under an expandable panel will be added where you can fill in details for your customers on how to measure their measurements",
    "newest-5-recommendations-given-to-your-customers": "Newest 5 recommendations given to your customers",
    "size-recommended": "Size Recommended",
    "view-all-data": "View all data",
    "please-select-a-size-worn": "Please select a size worn",
    "recommended-for-this-garment-add-or-remove-as-needed": "Recommended for this garment, add or remove as needed",
    "add-more": "Add more",
    "add-custom-measurements": "Add custom measurements",
    "skip-this-step-next-time": "Skip this step next time",
    "use-unit-conversion": "Use unit conversion",
    "disabled-by-chart": "Disabled by chart",
    "disabled-globally-by-settings": "Disabled globally by settings",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "Hide unit conversion toggle on all charts appear on your storefront",
    "assign-products": "Assign products",
    "select-products-to-assign-to-the-chart": "Select products to assign to the chart",
    "products-assigned-successfully": "Products assigned successfully",
    "source-table": "Source table",
    "root-table": "Main table",
    "table-block": "Table",
    "which-axis-holds-the-dimension-data": "Which axis holds the dimension data? (Shoulder, Waist, etc..)",
    "columns": "Columns",
    "rows": "Rows",
    "measurement-unit": "Measurement unit",
    "map-each-line-to-a-dimension": "Map each line to a dimension",
    "ignore": "Ignore",
    "line": "Line",
    "the-selected-table-has-no-data-to-map": "The selected table has no data to map.",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "Tell us how your table maps to body dimensions so we can suggest a size.",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "Choose which table the AI reads to suggest a size.",
    "per-dimension-stretch-and-easing-controls": "Per-dimension stretch and easing controls",
    "jump-to-table": "Jump to table",
    "scroll-to-the-selected-table": "Scroll to the selected table",
    "this-table-is-used-as-your-size-recommendation-data-source": "This table is used as your size-recommendation data source",
    "this-table-block-can-not-be-deleted-right-now": "This table block can not be deleted right now"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "There was an error while authenticating your store!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "Click the button below to try again. If the issue persisted, contact us for further instruction.",
    "refresh-the-app": "Refresh the app",
    "error-occured": "Error occured!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Add the Goodchart size guide button to your storefront",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "We've detected you are integrating with Shopify. Enable App embed to show the size guide button automatically on every product page, or add an App block to place it in a specific spot. Need help? See this <a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">guide</a>.",
    "enable-app-embed": "Enable App embed",
    "add-app-block": "Add App block",
    "your-new-size-chart-is-ready-to-review": "Your new size chart is ready to review",
    "look-around-then-hand-the-conversion-over": "Nothing has changed for your shoppers yet — your table chart is still the live one. Take your time checking the measurements and the guide, then hand the conversion over when it looks right.",
    "about-your-plan-usage": "About your plan usage",
    "measurements-applied": "Measurements applied",
    "selection-applied-all-variants": "The selection has been applied to all sizes variants.",
    "you-have-reached-x-of-ai-size-recommendations-limit": "You have reached {{ x }}% of your current tier plan AI size recommendations limit. Please aware that any usage over 100% will be charged with standard rate.",
    "you-have-reached-x-of-stock-notification-limit": "You have reached {{ x }}% of your current tier plan stock notification limit.",
    "over-usage-cost": "Over Usage Cost",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "You have exceeded your AI Size Recommendation limit. Please proceed to pay the over usage cost to continue using service.",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "You have exceeded your AI Size Recommendation limit. Please proceed to pay the over usage cost to continue using this feature.",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} of your table charts can be upgraded to smart size charts"
  },
  "onboarding": {
    "skip-for-now": "Skip for now",
    "step-x-of-y": "Step {{ x }} of {{ y }}",
    "select-the-category-that-best-matches-your-product": "Select the category that best matches your product.",
    "apparel": "Apparel",
    "tops": "Tops",
    "pants": "Pants",
    "dresses": "Dresses",
    "shoes": "Shoes",
    "sneakers": "Sneakers",
    "boots": "Boots",
    "sandals": "Sandals",
    "accessories": "Accessories",
    "belts": "Belts",
    "bags": "Bags",
    "hats": "Hats",
    "other-custom": "Other / Custom",
    "equipment": "Equipment",
    "tool": "Tool",
    "furniture": "Furniture",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "Upload any product image and place measurements visually. Works for apparel, shoes, and accessories.",
    "table-style-chart": "Table-style chart",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "Create a grid-based chart with rows and columns. Best for detailed size specifications.",
    "your-size-chart-is-ready": "Your size chart is ready",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "You can now decide where this size chart should appear in your store. You can skip this step and assign products later.",
    "apply-this-chart-to-products-now": "Apply this chart to products now",
    "choose-which-products-should-use-this-size-chart": "Choose which products should use this size chart.",
    "i-ll-do-this-later": "I'll do this later",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "You can assign or change matching anytime from chart settings.",
    "select-products-to-assign-chart-to": "Select products to assign chart to",
    "apply-this-chart-to-all-products": "Apply this chart to all products.",
    "select-products-to-apply-this-chart-to": "Select products to apply this chart to.",
    "assigning...": "Assigning...",
    "size-chart-created-successfully": "Size chart created successfully",
    "you-can-assign-products-anytime-from-chart-settings": "You can assign products anytime from chart settings.",
    "view-chart": "View chart",
    "go-to-dashboard": "Go to dashboard",
    "turn-your-size-chart-into-a-conversion-tool": "Turn your size chart into a conversion tool",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "Help shoppers pick the right size and reduce returns.",
    "setup-takes-about-2-minutes": "Setup takes about 2 minutes.",
    "choose-how-your-size-chart-looks": "Choose how your size chart looks",
    "other-ways-to-create-a-chart": "Other ways to create a chart",
    "failed-to-proceed-please-try-again": "Failed to proceed, please try again",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "This chart connects to your Shopify product and variants, so shoppers can select their size, Add to Cart, or Buy now without leaving the chart",
    "add-the-size-guide-button-to-your-storefront": "Add the size guide button to your storefront",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "Choose how the GoodChart size guide button should appear on your product pages.",
    "enable-app-embed": "Enable app embed",
    "installed": "Installed",
    "automatically-display-the-size-guide-button-on-all-product-pages": "Automatically display the size guide button on all product pages.",
    "add-app-block-to-product-page": "Add app block to product page",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "Prefer to place the button in a specific spot on your product page?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "Place the size guide button in a specific spot on your product page template.",
    "open": "Open",
    "check-button-installation": "Check button installation",
    "checking": "Checking...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "Great! The size guide button is installed on your storefront.",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "We couldn't detect the size guide button yet. Please make sure you saved the changes in the theme editor.",
    "app-block-installed-on-your-product-page": "App block installed on your product page"
  },
  "common": {
    "updated": "Updated",
    "name": "Name",
    "avatar": "Avatar",
    "category-image": "Category image",
    "increase": "Increase",
    "created": "Created",
    "email": "Email",
    "password": "Password",
    "yes": "Yes",
    "no": "No",
    "chart": "Chart",
    "gender": "Gender",
    "height": "Height",
    "weight": "Weight",
    "age-group": "Age group",
    "fit-preference": "Fit preference",
    "score": "Score",
    "table-chart": "Table chart",
    "draft": "Draft",
    "active": "Active",
    "products": "Products",
    "none": "None",
    "cancel": "Cancel",
    "retry": "Retry",
    "delete": "Delete",
    "export": "Export",
    "variant": "Variant",
    "variants": "Variants",
    "account": "Account",
    "personal": "Personal",
    "appearance": "Appearance",
    "organization": "Organization",
    "information": "Information",
    "first-name": "First name",
    "last-name": "Last name",
    "save": "Save",
    "pay": "Pay",
    "undo": "Undo",
    "redo": "Redo",
    "newsletter-subscription": "Newsletter subscription",
    "button": "Button",
    "colour": "Colour",
    "default": "Default",
    "white": "White",
    "light-grey": "Light Grey",
    "soft-beige": "Soft beige",
    "saving...": "Saving...",
    "all-changes-saved": "All changes saved",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "images": "Images",
    "charts": "Charts",
    "confirm": "Confirm",
    "dimensions": "Dimensions",
    "new": "New",
    "missing": "Missing",
    "editing-x": "Editing {{ x }}",
    "back-in-stock": "Back in stock",
    "product": "Product",
    "grading": "Grading",
    "more-actions": "More actions",
    "table": "Table",
    "measurement": "Measurement",
    "close": "Close",
    "apply": "Apply",
    "duplicate": "Duplicate",
    "add-layout-blocks": "Add layout blocks",
    "text": "Text",
    "image": "Image",
    "video": "Video",
    "new-name": "New name",
    "published": "Published",
    "all": "All",
    "editing": "Editing",
    "show-more": "Show more",
    "loading": "Loading",
    "or": "Or",
    "browse-files": "Browse files",
    "edit": "Edit",
    "customize": "Customize",
    "clear": "Clear",
    "label": "Label",
    "discard-changes": "Discard changes",
    "uploading": "Uploading...",
    "preset": "Preset",
    "custom": "Custom",
    "manage": "Manage",
    "done": "Done",
    "reminder": "Reminder",
    "collections": "Collections",
    "all-products": "All products",
    "select": "Select",
    "search": "Search",
    "select-all": "Select all",
    "size-chart": "Size chart",
    "continue": "Continue",
    "back": "Back",
    "visual-measurement-builder": "Visual Measurement Builder",
    "recommend": "Recommend",
    "creating...": "Creating...",
    "syncing": "Syncing...",
    "preview": "Preview",
    "create": "Create",
    "onboarding": "Onboarding",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "czech": "Czech",
    "danish": "Danish",
    "german": "German",
    "italian": "Italian",
    "dutch": "Dutch",
    "japanese": "Japanese",
    "off": "Off",
    "basic": "Basic",
    "AI": "AI",
    "details": "Details",
    "date": "Date",
    "billing": "Billing",
    "settings": "Settings",
    "log-out": "Log out",
    "plan": "Plan",
    "ai-size-recommendation": "AI Size Recommendation",
    "recommendations": "Recommendations",
    "features": "Features",
    "stock-notification": "Stock Notification",
    "published-size-charts": "Published Size Charts",
    "published-table-charts": "Published Table Charts",
    "unlimited": "Unlimited",
    "x-of-y": "{{ x }} of {{ y }}",
    "measurements": "Measurements",
    "selected": "Selected",
    "select-product": "Select product",
    "price": "Price",
    "title": "Title",
    "message": "Message",
    "add": "Add",
    "remove": "Remove",
    "cm": "cm",
    "in": "in",
    "usd": "USD",
    "return": "Return",
    "next": "Next",
    "store": "Store",
    "type": "Type",
    "cost": "Cost",
    "incurred-at": "Incurred at",
    "search-placeholder": "Search...",
    "more": "More...",
    "load-more": "Load more...",
    "status": "Status",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "total": "Total",
    "un-listed": "Un-listed",
    "global": "Global",
    "store-specific": "Store-specific",
    "ai-measurement-import": "AI Measurement Import",
    "included": "Included",
    "not-included": "Not included"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "Successfully updated your preferences",
    "failed-to-update-your-preferences": "Failed to update your preferences"
  },
  "import": {
    "upload-file": "Upload file",
    "sheet-import": {
      "title": "Upload measurements from a file",
      "dropzone": {
        "title": "Drag and drop a file here",
        "accepted-types": "{{types}} — one file at a time",
        "browse": "Browse files"
      },
      "hint": "Best results: one table whose size labels match this chart's variants, with headers in the first row or column. For a photo or screenshot, keep it sharp and straight-on, and crop out anything but the table.",
      "example": {
        "caption": "Example of an accepted layout:",
        "size": "Size",
        "chest": "Chest (cm)",
        "waist": "Waist (cm)"
      },
      "error": {
        "invalid-type": "That file type isn't supported. Upload one of: {{types}}.",
        "heic-unsupported": "HEIC photos (the iPhone format) aren't supported. Export the photo as JPG or PNG and upload that instead.",
        "file-too-large": "That file is too large. The maximum size is {{maxSizeMb}} MB."
      },
      "submit": "Upload and review changes",
      "running": {
        "this-chart": "An import is already running for this chart.",
        "other-chart": "An import is already running for another chart. Only one import can run at a time.",
        "open-import": "View import"
      },
      "accepted-files-tooltip": "Accepted files: {{types}}",
      "button": {
        "importing": "Importing… {{progress}}%",
        "review": "Review import"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "Find your best size",
      "subtitle": "A few quick details for a better fit",
      "shopping-for": "SHOPPING FOR",
      "women": "Women",
      "men": "Men",
      "other": "Other",
      "measurements": "MEASUREMENTS",
      "height": "Height",
      "height-required": "Height is required",
      "min-height": "Min height is 1",
      "weight": "Weight",
      "weight-required": "Weight is required",
      "min-weight": "Min weight is 1",
      "preferred-fit": "Preferred fit"
    },
    "result": {
      "suggested-size": "Suggested Size:",
      "no-fit": "Unfortunately, it seems we don't have an ideal size at the moment. We recommend checking back later for more options.",
      "verdict": "Verdict:",
      "similar-variants": "Similar variants:",
      "proceed": "Proceed with this variant",
      "estimate-disclaimer": "(Estimate based on brand and user info, results may vary.)"
    },
    "ai": {
      "upgrade-title": "Upgrade your plan to unlock AI Size Recommendation",
      "upgrade-description": "A feature that helps your customers find the right size every time. Our AI analyzes product details and customer inputs to give personalized size suggestions, so shoppers buy with confidence and you see fewer returns and exchanges. Upgrade now to offer this experience on your store.",
      "image-alt": "Size Recommendation",
      "upgrade-enable": "Upgrade and Enable now",
      "explore-plans": "Explore other plans",
      "failed-load-recommendations": "Failed to load recommendations",
      "failed-fetch-plans": "Failed to fetch plans",
      "form-tab": "Form",
      "result-tab": "Result"
    },
    "basic": {
      "measurements-required-title": "Add measurements first",
      "measurements-required-description": "Basic size recommendation matches buyers to a size using this chart's measurements. Add measurements to the chart, then turn it on."
    }
  },
  "chart-limit": {
    "title-size": "You've reached your published size chart limit",
    "title-table": "You've reached your published table chart limit",
    "description-size": "Your plan lets you publish {{limit}} size charts, and you have {{usage}} published. This chart has been kept as a draft. Upgrade to publish more, or unpublish a chart you no longer need.",
    "description-table": "Your plan lets you publish {{limit}} table charts, and you have {{usage}} published. This chart has been kept as a draft. Upgrade to publish more, or unpublish a chart you no longer need.",
    "upgrade-plan": "Upgrade plan",
    "explore-plans": "Explore plans",
    "failed-fetch-plans": "Couldn't load plans. Please try again.",
    "image-alt": "Chart illustration",
    "onboarding-saved-as-draft": "Your chart was saved as a draft because your plan's published chart limit is reached. You can publish it after upgrading or unpublishing another chart."
  },
  "help-centre": "Help centre",
  "dimension-inputs": {
    "add-measurement": "Add measurement"
  },
  "variant-editor": {
    "option-name": "Option name",
    "option-values": "Option values",
    "option-placeholder": "Size / Color / Fabric",
    "add-option": "Add another option"
  },
  "dimension": {
    "shoulder": "Shoulder",
    "bust": "Bust",
    "waist": "Waist",
    "arm": "Arm",
    "sleeve": "Sleeve",
    "hip": "Hip",
    "crotch": "Crotch",
    "leg": "Leg",
    "thigh": "Thigh",
    "length": "Length",
    "bottom_width": "Bottom width",
    "chest": "Chest",
    "inside_leg": "Inside leg",
    "back_length": "Back length",
    "front_length": "Front length",
    "front_rise": "Front rise",
    "back_rise": "Back rise",
    "leg_opening": "Leg opening",
    "overbust": "Overbust",
    "underbust": "Underbust",
    "groups": {
      "tops": "Tops",
      "bottoms": "Bottoms",
      "generals": "Generals"
    }
  },
  "analytic": {
    "range": {
      "1m": "1 month",
      "3m": "3 months",
      "6m": "6 months",
      "1y": "1 year"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "A restore is already running for this store. Wait for it to finish and try again.",
    "a-snapshot-is-taken-only-on-days-you-change-something": "A snapshot is taken only on days you change something.",
    "actor": {
      "merchant": "you",
      "support": "Goodchart support",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "Your billing, plan, login and connected integrations are not touched.",
    "blocked": {
      "entity-exists": "Already recreated — restore instead",
      "entity-missing": "No longer exists — restore instead",
      "unsupported": "Cannot be undone — restore instead",
      "value-changed": "Changed since — restore instead"
    },
    "changes": "Changes",
    "discard-unsaved-changes": "Discard unsaved changes?",
    "dont-ask-again-in-this-session": "Don’t ask again in this session",
    "earlier": "Earlier",
    "history": "History",
    "history-starts-from-your-first-snapshot": "History starts from your first snapshot",
    "label": {
      "category-created": "Created category {{name}}",
      "category-deleted": "Deleted category {{name}}",
      "category-updated": "Edited category {{name}}",
      "chart-created": "Created chart {{name}}",
      "chart-deleted": "Deleted chart {{name}}",
      "chart-updated": "Edited chart {{name}}",
      "dimension-created": "Created measurement {{name}}",
      "dimension-deleted": "Deleted measurement {{name}}",
      "dimension-updated": "Edited measurement {{name}}",
      "draft-assignment-rules": "Changed assignment rules",
      "draft-edited": "Edited the chart",
      "draft-guide": "Edited the measuring guide",
      "draft-labels": "Edited size labels",
      "draft-measurements": "Edited measurements",
      "draft-model": "Changed model measurements",
      "draft-publication": "Changed publication",
      "draft-renamed": "Renamed the chart",
      "draft-size-recommender": "Changed the size recommender",
      "draft-variants": "Edited variants",
      "keyword-created": "Created keyword {{name}}",
      "keyword-deleted": "Deleted keyword {{name}}",
      "keyword-updated": "Edited {{count}} keywords",
      "products-assigned": "Assigned {{count}} products",
      "profile-updated": "Updated store profile",
      "store-restored": "Restored the store to {{date}}",
      "table-chart-created": "Created table chart {{name}}",
      "table-chart-deleted": "Deleted table chart {{name}}",
      "table-chart-updated": "Edited table chart {{name}}"
    },
    "no-changes-since-then": "No changes since then.",
    "no-snapshots-yet": "No snapshots yet",
    "nothing-created-since-then-will-be-deleted": "Nothing created since then will be deleted.",
    "plus-x-more": "+{{x}} more",
    "reloading-the-dashboard": "Reloading the dashboard…",
    "restore": "Restore",
    "restore-confirmation-word": "RESTORE",
    "restore-instead": "Restore instead",
    "restore-your-store": "Restore your store",
    "restoring-your-store-do-not-close-this-window": "Restoring your store. Do not close this window.",
    "since-the-x-snapshot": "Since the {{x}} snapshot",
    "snapshots": "Snapshots",
    "the-change-was-undone-but-the-page-could-not-refresh": "The change was undone, but this page could not refresh. Reload to see it.",
    "this-backup-predates-image-protection": "This backup was taken before we started protecting images, so any image deleted since cannot be brought back.",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "This changes what shoppers see on your product pages within seconds.",
    "this-changes-what-shoppers-see-right-away": "This changes what shoppers see right away.",
    "this-puts-your-store-back-to-how-it-was-on-x": "This puts your store back to how it was on {{x}}.",
    "this-reverses-x-actions-up-to-and-including-y": "This reverses {{x}} actions, up to and including “{{y}}”.",
    "trigger": {
      "daily": "Daily",
      "install": "When you installed Goodchart",
      "manual": "Manual (support)",
      "migration": "First snapshot",
      "pre-restore": "Before restore",
      "reinstall": "When you reinstalled Goodchart"
    },
    "type-x-to-confirm": "Type {{x}} to confirm",
    "undid-x": "Undid “{{x}}”",
    "undo-a-saved-change": "Undo a saved change",
    "undo-to-here": "Undo to here",
    "undo-x-saved-y": "Undo “{{x}}”, saved {{y}}?",
    "unsaved": "Unsaved",
    "we-could-not-load-your-history": "We could not load your history.",
    "we-could-not-load-your-snapshots": "We could not load your snapshots.",
    "we-could-not-restore-your-store": "We could not restore your store.",
    "we-could-not-work-out-what-would-change": "We could not work out what would change.",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "We take a snapshot of your current store first, so this can be undone.",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "We take a snapshot of your store on each day it changes. Your history will appear here once the first one is taken.",
    "what-comes-back": "What comes back",
    "what-is-lost": "What is lost",
    "working-out-what-would-change": "Working out what would change…",
    "x-assignments": "{{x}} assignments",
    "x-charts": "{{x}} charts",
    "x-images-cannot-be-brought-back": "{{x}} images cannot be brought back — they were deleted more than 37 days ago.",
    "x-images-could-not-be-recovered": "{{x}} images could not be recovered — they were deleted more than 37 days ago.",
    "x-items-created-since-then-will-be-deleted": "{{x}} items created since then will be deleted, including:",
    "x-items-will-be-recreated": "{{x}} items will be recreated.",
    "x-no-longer-exists-after-the-undo": "“{{x}}” no longer exists after the undo.",
    "x-table-charts": "{{x}} table charts",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "You have unsaved changes to “{{x}}”. Undoing will discard them.",
    "your-store-has-been-restored": "Your store has been restored."
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "Reading your file",
        "understanding-table": "Understanding the table",
        "matching-measurements": "Matching measurements",
        "building-chart": "Building your chart"
      },
      "reconnecting": "Reconnecting — hang tight, your progress isn't lost.",
      "keep-working": "You can keep working — we'll notify you when it's ready.",
      "cancel": "Cancel import",
      "cancel-confirm": {
        "title": "Cancel this import?",
        "message": "Your uploaded file will be discarded and this import cannot be resumed.",
        "keep": "Keep waiting",
        "discard": "Cancel import"
      },
      "ready": {
        "title": "Chart ready to review",
        "action": "Review changes"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "That photo was too blurry or dark for us to read. A clearer, well-lit photo works best."
      },
      "no-table-found": {
        "message": "We couldn't find a size table in this file."
      },
      "unsupported-layout": {
        "message": "This table's layout isn't one we can read yet."
      },
      "model-timeout": {
        "message": "That took too long — this is usually a temporary hiccup."
      },
      "internal": {
        "message": "Something went wrong on our end while importing your chart."
      },
      "action": {
        "retry": "Retry",
        "try-another-photo": "Try another photo",
        "try-another-file": "Try another file",
        "other-methods": "Other methods"
      }
    },
    "diff-review": {
      "title": "Review changes",
      "subtitle": "Uncheck anything you don't want applied to this chart.",
      "load-error": "We couldn't load the changes for this import.",
      "no-changes": "No measurements changed.",
      "grid": {
        "variant": "Size",
        "dimension": "Measurement",
        "old-value": "Current",
        "new-value": "New"
      },
      "unmatched-variants": "Sizes in the file that don't match this chart:",
      "unmapped-dimensions": "Columns we couldn't match to a measurement:",
      "apply": {
        "button": "Apply changes ({{count}})",
        "success": "Chart updated ({{count}} changes applied)",
        "generic-error": "We couldn't apply these changes. Please try again."
      },
      "cancel": {
        "button": "Cancel import"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "Cancel this import?",
        "message": "Your uploaded file and review changes will be discarded. This import cannot be resumed.",
        "keep": "Keep reviewing",
        "discard": "Cancel import"
      }
    },
    "page": {
      "title": "Import measurements",
      "empty": {
        "title": "No import is running for this chart",
        "message": "Upload a spreadsheet or a photo of a size table to update this chart's measurements."
      }
    },
    "upgrade": {
      "title": "Import measurements with AI",
      "description": "Upload a spreadsheet or a photo of a size table and we'll fill in this chart's measurements for you. AI measurement import isn't included in your current plan. Upgrade to use it.",
      "upgrade-plan": "Upgrade plan",
      "explore-plans": "Explore plans",
      "failed-fetch-plans": "Couldn't load plans. Please try again.",
      "image-alt": "Size table illustration"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday",
      "chip": "Black Friday price",
      "popup": {
        "eyebrow": "Black Friday · Cyber Monday",
        "headline": "Up to {{percent}}% off",
        "subheadline": "Goodchart plans",
        "body": "Get your size charts ready for your busiest week of the year. Clear sizing means fewer \"will this fit?\" questions and fewer returns.",
        "feature-recommender": "AI size recommender that suggests each shopper's size",
        "feature-import": "AI import that turns a file or image into a size chart",
        "feature-analytics": "Analytics on how shoppers use your size charts",
        "cta": "See the deals",
        "later": "Maybe later"
      },
      "show-offer": "Show the Black Friday offer"
    },
    "every-plan": "{{percent}}% off every plan",
    "up-to": "Up to {{percent}}% off",
    "switch-to": "Switch to ${{price}}/{{interval}}",
    "switch-from": "You're on {{name}} at ${{price}}/{{interval}}. Same features, {{percent}}% less.",
    "switch-note-monthly": "Shopify asks you to approve the new price and credits the rest of this month.",
    "switch-note-annual": "Shopify asks you to approve the new price, which starts at your renewal on {{date}}.",
    "switch-note-annual-undated": "Shopify asks you to approve the new price, which starts at your next renewal."
  },
  "agent-chat": {
    "open": "Open support chat",
    "close": "Close support chat",
    "expand": "Enlarge the chat",
    "collapse": "Shrink the chat",
    "title": "Goodchart support",
    "history": "Conversations",
    "back": "Back to the conversation",
    "new": "New conversation",
    "placeholder": "Ask a question about Goodchart",
    "send": "Send",
    "welcome": "Hi! Ask me anything about Goodchart: setting up size charts, the size guide on your store, or your plan.",
    "history-empty": "No conversations yet.",
    "unread": "New reply",
    "you": "You",
    "merchant": "Merchant",
    "assistant": "Goodchart assistant",
    "team": "Goodchart team",
    "typing": "Writing…",
    "used-articles": "Answered from the help articles",
    "retry": "Try again",
    "activity": {
      "articles": "Reading the help articles…",
      "store": "Looking at your store…",
      "code": "Checking how Goodchart works…",
      "team": "Passing this to the Goodchart team…"
    },
    "error": {
      "rate-limited": "You're sending messages quickly. Try again in {{seconds}} seconds. If you need the Goodchart team, ask me for them once you can send again.",
      "daily-cap": "You've reached today's message limit. Try again tomorrow, and ask me for the Goodchart team then if you still need them.",
      "disabled": "The support assistant is unavailable right now.",
      "reply-failed": "The reply didn't come through.",
      "unknown": "Something went wrong."
    },
    "placeholder-team": "Add details for the Goodchart team",
    "unavailable": "The support assistant is unavailable right now, so it can't take new questions. Conversations already with the Goodchart team stay open in your history.",
    "waiting": {
      "title": "Waiting for the Goodchart team.",
      "body": "They'll reply here and you'll get a notification. You can add details in the meantime."
    },
    "starters": {
      "create-chart": "How do I create a size chart?",
      "no-chart": "Which of my products have no size chart?",
      "not-showing": "Why isn't my size chart showing on my store?",
      "charts-left": "How many more charts can I publish?"
    },
    "feedback": {
      "helpful": "Helpful",
      "not-helpful": "Not helpful",
      "thanks": "Thanks for your feedback.",
      "comment-placeholder": "What was wrong or missing? (optional)",
      "send": "Send",
      "skip": "Skip",
      "rated-up": "Rated helpful",
      "rated-down": "Rated not helpful"
    }
  }
}
